import { useRef, useState } from "react";
import { SidebarMenu } from "../sidebarMenu/sidebarMenu";
import {
  LayoutContentModel,
  LayoutHeaderModel,
  LayoutHeaderTitleModel,
  LayoutModel,
} from "./layoutModel";
import { Collapse, Dropdown, Placeholder, Row } from "react-bootstrap";
import { Toaster } from "sonner";
import { useTranslation } from "react-i18next";
import profilePicturePlaceholder from "./assets/profile-picture-placeholder.png";
import { useAppSelector } from "../../../../../hooks/useTypedSelector";

export const Layout = ({ children, header }: LayoutModel) => {
  const isMobile = window.innerWidth > 768;
  const [open, setOpen] = useState(isMobile);

  const collapseRef = useRef(null);
  const divRef = useRef<HTMLDivElement>(null);

  const updateDOM = () => {
    if (
      divRef.current == null ||
      collapseRef.current == null ||
      "state" in collapseRef.current === undefined
    )
      return;
    const { state } = collapseRef.current as {
      state: { status: string };
    };
    if ("status" in state === undefined) return;
    if (state.status === "entered") {
      divRef.current.classList.remove("exiting");
    } else {
      divRef.current.classList.add("exiting");
    }
  };

  return (
    <div
      className="layout"
      onClick={(event) => {
        if (window.innerWidth > 768 || !open) return;
        if ((event.target as Element).classList.contains("layout-index")) {
          setOpen(false);
          updateDOM();
        }
      }}
    >
      <Toaster position="top-center" richColors />
      <Collapse in={open} dimension="width" ref={collapseRef}>
        <div className="layout-sidebar" id="sidebar">
          <SidebarMenu
            isMobile={isMobile}
            open={open}
            setOpen={setOpen}
            updateDOM={updateDOM}
          />
        </div>
      </Collapse>
      <div className="layout-index exiting" ref={divRef}>
        <header>
          <div className="header-sidebar-nav">
            <nav className="navbar navbar-light">
              <button
                className="navbar-toggler"
                type="button"
                onClick={() => {
                  setOpen(!open);
                  updateDOM();
                }}
                aria-controls="sidebar"
                aria-expanded={open}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </nav>
          </div>
          {header}
        </header>
        {children}
      </div>
    </div>
  );
};

export const LayoutContent = ({ children }: LayoutContentModel) => {
  return (
    <div className="layout-content">
      <Row>{children}</Row>
    </div>
  );
};

export const LayoutHeader = ({ children, logout }: LayoutHeaderModel) => {
  const { t } = useTranslation("common");
  const currentUser = useAppSelector((state) => state.auth.user);

  return (
    <>
      <div className="header">
        <Dropdown className="header-account-menu">
          <Dropdown.Toggle className="header-account-menu-button">
            <img src={profilePicturePlaceholder} alt={"profile picture"} />
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <Dropdown.Item href={`/user/edit/${currentUser.id}`}>
              {t("Account page")}
            </Dropdown.Item>
            <Dropdown.Item
              href="#"
              onClick={(event) => {
                event.preventDefault();
                logout();
              }}
            >
              {t("Logout")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="bottom">{children}</div>
    </>
  );
};

export const LayoutHeaderTitle = ({
  title,
  loading,
  children,
}: LayoutHeaderTitleModel) => {
  if (loading)
    return (
      <p className="placeholder-glow " style={{ width: 200, margin: 0 }}>
        <Placeholder xs={12} bg="light" />
      </p>
    );

  return (
    <div style={{ paddingRight: "10px", borderRight: "2px solid #CECECE" }}>
      <div className={"d-flex"}>
        <h3 className="header-title">{title}</h3>
        {children}
      </div>
    </div>
  );
};

export const LayoutHeaderActions = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div className="ms-auto">{children}</div>;
};
